<template>
  <div class="bannerList" >
   
     <el-carousel height="125px" arrow="never" :indicator-position='"none"'>
      <el-carousel-item >
        <img :src="banner.url" alt="">
        <!-- <el-image  :src="banner.url" fit="cover"></el-image> -->
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { bannerList } from '@/api/common_api'
export default {
  name: 'bannerList',
  data () {
    return {
      banner:'',
      
    }
  },
  computed: {
    getText() {
      
    },
    
  },
  created () {
    this.getBanner()
  },
  methods: {
    getBanner(){
      let _this = this
      
      bannerList().then(res => {
        if (res.s == 1) {
         _this.banner=res.d[0]
        
        }
      })
      
    },
    
  }
}
</script>
<style lang="less" scoped>
.bannerList{
  // background:#000;
  position: relative;
  img{
    height:100%;
    width:100%;
  }
  .right-set{
    position: absolute;
    right:10Px;
    top:10Px;
    z-index:88;
    cursor: pointer;
    .icon{
      font-size:20Px;
    }
  }
}
</style>

